import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import { CsvBuilder } from "filefy";
import sort from "fast-sort";

import _ from "lodash";

import { formatSecondsForDate } from "../../layout/utils/timeUtils";

export default (props) => {
  const download = () => {
    const rows = [];
    sort(props.reportData)
      .asc([(r) => r.created.seconds])
      .map((e) =>
        rows.push([
          e.name,
          e.email,
          e.practiceRating,
          e.practiceComment,
          e.providerRating,
          e.providerComment,
          formatSecondsForDate(e.created.seconds),
        ])
      );

    const date = new Date();
    const builder = new CsvBuilder(
      "client_satisfaction_report" + date.toLocaleDateString() + ".csv"
    );
    builder
      .setDelimeter(",")
      .setColumns([
        "Name",
        "Email",
        "Practice Rating",
        "Practice Comment",
        "Provider Rating",
        "Provider Comment",
        "Date Submitted",
      ])
      .addRows(rows)
      .exportFile();
  };

  return !_.isEmpty(props.reportData) && props.reportData.length > 0 ? (
    <div>
      <p>
        The CSAT metric is looking specifically at the percentage of happy
        customers and is calculated by looking at the 4 to 5 ratings you've
        received. The formula is: (The total Number of 4 and 5 responses) ÷
        (Number of total responses) x 100 = % of satisfied customers. For
        example, a CSAT rating of 80% means that the majority of customers are
        giving a satisfied rating. If you’re using CSAT already and you’re not
        sure how you compare to your peers, a good resource is the American
        Customer Satisfaction Index. According to the index, the current overall
        U.S. Customer Satisfaction Score is 76.5%.
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          marginBottom: 20,
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          disabled={_.isEmpty(props.reportData) || props.reportData.length < 1}
          onClick={download}
        >
          Download Survey Results
        </Button>
      </div>
      <TableContainer
        component={Paper}
        style={{ maxHeight: 400, overflow: "auto" }}
      >
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "#f5f5f5" }}>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell align="center">Practice Rating</TableCell>
              <TableCell align="center">Practice Comment</TableCell>
              <TableCell align="center">Provider Rating</TableCell>
              <TableCell align="center">Provider Comment</TableCell>
              <TableCell align="center">Date Submitted</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.reportData &&
              sort(props.reportData)
                .asc([(r) => r.created.seconds])
                .map((row) => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row">
                      {row.name ? row.name : "Anonymous"}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.email}
                    </TableCell>
                    <TableCell align="center">{row.practiceRating}</TableCell>
                    <TableCell align="center">{row.practiceComment}</TableCell>
                    <TableCell align="center">{row.providerRating}</TableCell>
                    <TableCell align="center">{row.providerComment}</TableCell>
                    <TableCell align="center">
                      {row.created && formatSecondsForDate(row.created.seconds)}
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  ) : (
    <h3>
      Your Patients/Clients have not submitted the Client Satisfaction survey
      yet.
    </h3>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/CSATReport.js